/**
 * MyFlowers-style OTP UI — never navigates to Shopify hosted "My Store" login.
 * Uses divs + type=button (not <form>/type=email) so Shopify CA scripts cannot hijack.
 * v4: after OTP success stay on /pages/sign-in (no location.href handoff).
 */
(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var sendPanel = qs(root, '[data-auth-panel="send"]');
    var verifyPanel = qs(root, '[data-auth-panel="verify"]');
    var successPanel = qs(root, '[data-auth-panel="success"]');
    var channel = 'sms';
    var contact = '';
    var iti = null;
    var expectedCode = '';
    var timerId = null;
    var otpMode = (root.getAttribute('data-otp-mode') || 'mock').toLowerCase();
    var otpEndpoint = (root.getAttribute('data-otp-endpoint') || '').replace(/\/$/, '');

    if (otpMode === 'authyo') {
      var sendInner = qs(root, '[data-auth-panel="send"] .otp-login-form__inner');
      if (sendInner) {
        var note = document.createElement('div');
        note.style.cssText = 'margin:0 0 16px;padding:12px 14px;border-radius:10px;background:#ebfaf0;border:1px solid #cfe8d6;font-size:13px;line-height:1.45;color:#1f2226;';
        note.innerHTML = '<strong>Authyo mode</strong><br>Install <em>Authyo OTP Login</em> from the Shopify App Store, enable its theme embed, then customers can sign in with SMS/Email OTP. Until Authyo is active, the form below stays in demo mode.';
        sendInner.insertBefore(note, sendInner.firstChild);
      }
      otpMode = 'mock';
    }

    function show(panel) {
      qsa(root, '[data-auth-panel]').forEach(function (el) {
        el.hidden = el.getAttribute('data-auth-panel') !== panel;
      });
      root.setAttribute('data-state', panel === 'verify' ? 'verify' : (panel === 'success' ? 'success' : 'send'));
    }

    function setChannel(next) {
      channel = next === 'email' ? 'email' : 'sms';
      sendPanel.setAttribute('data-form-state', channel);
      qsa(verifyPanel, '.otp-login-form').forEach(function (el) {
        el.setAttribute('data-form-state', channel);
      });
      var phoneWrap = qs(sendPanel, '[data-input="phone"]');
      var emailWrap = qs(sendPanel, '[data-input="email"]');
      if (phoneWrap) phoneWrap.hidden = channel !== 'sms';
      if (emailWrap) emailWrap.hidden = channel !== 'email';
      updateSubmit();
      if (channel === 'sms') initIti();
    }

    function activeInput() {
      return channel === 'sms'
        ? qs(sendPanel, 'input[name="florai_phone"]')
        : qs(sendPanel, 'input[name="florai_email"]');
    }

    function isEmailValid(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
    }

    function updateSubmit() {
      var btn = qs(sendPanel, '[data-send-submit]');
      var input = activeInput();
      if (!btn || !input) return;
      var ok = channel === 'email'
        ? isEmailValid(input.value)
        : (input.value || '').replace(/\D/g, '').length >= 7;
      btn.disabled = !ok;
    }

    function initIti() {
      var phoneInput = qs(sendPanel, 'input[name="florai_phone"]');
      if (!phoneInput || !window.intlTelInput || iti) return;
      iti = window.intlTelInput(phoneInput, {
        initialCountry: 'gb',
        preferredCountries: ['gb'],
        loadUtils: function () {
          return import('https://cdn.jsdelivr.net/npm/intl-tel-input@29.0.1/dist/js/utils.js');
        }
      });
    }

    function getContactValue() {
      if (channel === 'email') {
        return (qs(sendPanel, 'input[name="florai_email"]').value || '').trim();
      }
      var phoneInput = qs(sendPanel, 'input[name="florai_phone"]');
      if (iti && typeof iti.getNumber === 'function') {
        try { return iti.getNumber() || phoneInput.value.trim(); } catch (e) {}
      }
      return phoneInput.value.trim();
    }

    function setLoading(isLoading) {
      var btn = qs(sendPanel, '[data-send-submit]');
      if (!btn) return;
      var text = btn.querySelector('.btn-text');
      var spinner = btn.querySelector('.btn-spinner');
      var input = activeInput();
      var ok = input && (channel === 'email'
        ? isEmailValid(input.value)
        : (input.value || '').replace(/\D/g, '').length >= 7);
      btn.disabled = isLoading || !ok;
      if (text) text.hidden = !!isLoading;
      if (spinner) spinner.hidden = !isLoading;
    }

    function makeCode() {
      return String(Math.floor(100000 + Math.random() * 900000));
    }

    function startTimer() {
      var resend = qs(verifyPanel, '.otp-login-form--resend');
      var timerEl = qs(verifyPanel, '.timer');
      var resendBtn = qs(verifyPanel, '[data-resend-btn]');
      var remaining = 60;
      if (timerId) clearInterval(timerId);
      if (resend) resend.setAttribute('data-resend-state', 'counting');
      if (resendBtn) resendBtn.hidden = true;
      if (timerEl) timerEl.textContent = '0:60';
      timerId = setInterval(function () {
        remaining -= 1;
        if (timerEl) timerEl.textContent = remaining < 10 ? '0:0' + remaining : '0:' + remaining;
        if (remaining <= 0) {
          clearInterval(timerId);
          if (resend) resend.setAttribute('data-resend-state', 'finished');
          if (resendBtn) resendBtn.hidden = false;
        }
      }, 1000);
    }

    function goVerify() {
      contact = getContactValue();
      var toEl = qs(verifyPanel, '[data-verify-to]');
      if (toEl) toEl.textContent = contact;

      var hint = qs(verifyPanel, '[data-otp-hint]');
      if (!hint) {
        hint = document.createElement('p');
        hint.setAttribute('data-otp-hint', '');
        hint.style.cssText = 'text-align:center;font-size:13px;color:#7c7c7c;margin:0 0 12px;line-height:1.4;';
        var form = qs(verifyPanel, '[data-verify-form]');
        if (form) form.parentNode.insertBefore(hint, form);
      }

      var realInput = qs(verifyPanel, '.otp-login-form__otp-real-input');
      var hidden = qs(verifyPanel, '[data-code-value]');
      if (realInput) { realInput.value = ''; delete realInput.dataset.bound; }
      if (hidden) hidden.value = '';
      qsa(verifyPanel, '.otp-login-form__otp-box').forEach(function (b) {
        b.textContent = '';
        b.classList.remove('is-filled', 'is-active', 'is-error');
      });
      var err = qs(verifyPanel, '[data-verify-errors]');
      if (err) { err.hidden = true; err.textContent = ''; }

      function openVerifyUI(msgHtml) {
        hint.innerHTML = msgHtml || 'Enter the code we sent you.';
        show('verify');
        startTimer();
        initOtpBoxes();
      }

      if (otpMode === 'worker' && otpEndpoint) {
        setLoading(true);
        fetch(otpEndpoint + '/otp/send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            channel: channel,
            to: contact,
            phone: channel === 'sms' ? contact : undefined,
            email: channel === 'email' ? contact : undefined
          })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            setLoading(false);
            if (!res.ok) {
              var sendErr = qs(sendPanel, '[data-signin-errors]');
              if (sendErr) {
                sendErr.hidden = false;
                sendErr.textContent = (res.j && (res.j.error || res.j.message)) || 'Could not send code. Try again.';
              }
              return;
            }
            expectedCode = '';
            try {
              sessionStorage.setItem('florai_otp', JSON.stringify({
                channel: channel, to: contact, at: Date.now(), mode: 'worker'
              }));
            } catch (e) {}
            openVerifyUI('Code sent. Check your ' + (channel === 'sms' ? 'phone' : 'email') + '.');
          })
          .catch(function () {
            setLoading(false);
            var sendErr = qs(sendPanel, '[data-signin-errors]');
            if (sendErr) {
              sendErr.hidden = false;
              sendErr.textContent = 'Network error sending code. Check the OTP worker URL.';
            }
          });
        return;
      }

      // Demo / mock mode (no real SMS or email)
      expectedCode = makeCode();
      try {
        sessionStorage.setItem('florai_otp', JSON.stringify({
          channel: channel, to: contact, code: expectedCode, at: Date.now(), mode: 'mock'
        }));
      } catch (e) {}
      openVerifyUI('Demo mode — use <strong style="color:#1f2226">' + expectedCode + '</strong> to continue. Install Authyo or set a worker URL for real SMS/email.');
    }

    function checkCode() {
      var hidden = qs(verifyPanel, '[data-code-value]');
      var code = (hidden && hidden.value) || '';
      var err = qs(verifyPanel, '[data-verify-errors]');
      var boxes = qsa(verifyPanel, '.otp-login-form__otp-box');

      function fail() {
        if (err) { err.hidden = false; err.textContent = 'Incorrect code. Please try again'; }
        boxes.forEach(function (b) { b.classList.add('is-error'); });
      }

      function pass() {
        if (err) { err.hidden = true; err.textContent = ''; }
        boxes.forEach(function (b) { b.classList.remove('is-error'); });
        finishLogin();
      }

      if (!code || code.length < 6) {
        fail();
        return;
      }

      if (otpMode === 'worker' && otpEndpoint) {
        fetch(otpEndpoint + '/otp/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            channel: channel,
            to: contact,
            phone: channel === 'sms' ? contact : undefined,
            email: channel === 'email' ? contact : undefined,
            code: code
          })
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok && (res.j.ok !== false)) pass();
            else fail();
          })
          .catch(fail);
        return;
      }

      if (code !== expectedCode) {
        fail();
        return;
      }
      pass();
    }

    function initOtpBoxes() {
      var realInput = qs(verifyPanel, '.otp-login-form__otp-real-input');
      var boxes = qsa(verifyPanel, '.otp-login-form__otp-box');
      var hidden = qs(verifyPanel, '[data-code-value]');
      if (!realInput || !boxes.length) return;
      if (realInput.dataset.bound) {
        realInput.focus();
        return;
      }
      realInput.dataset.bound = '1';

      var update = function () {
        var val = realInput.value.replace(/\D/g, '').slice(0, 6);
        realInput.value = val;
        if (hidden) hidden.value = val;
        boxes.forEach(function (box, i) {
          box.textContent = val[i] || '';
          box.classList.toggle('is-filled', !!val[i]);
          box.classList.toggle('is-active', i === Math.min(val.length, boxes.length - 1) && val.length < 6);
        });
        if (val.length === 6) {
          setTimeout(checkCode, 60);
        }
      };

      realInput.addEventListener('input', update);
      realInput.addEventListener('focus', update);
      setTimeout(function () { realInput.focus(); }, 80);
    }

    function finishLogin() {
      try {
        sessionStorage.setItem('florai_session', JSON.stringify({
          contact: contact, channel: channel, at: Date.now()
        }));
      } catch (e) {}
      if (timerId) clearInterval(timerId);
      var label = qs(successPanel, '[data-success-contact]');
      if (label) label.textContent = contact;
      show('success');
      // Open MyFlowers-style client dashboard (theme page — not Shopify hosted /account)
      setTimeout(function () {
        window.location.assign('/pages/my-account');
      }, 600);
    }

    qs(sendPanel, '[data-auth-toggle]').addEventListener('click', function () {
      setChannel(channel === 'sms' ? 'email' : 'sms');
    });

    sendPanel.addEventListener('input', updateSubmit);

    qs(sendPanel, '[data-send-submit]').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var input = activeInput();
      var errors = qs(sendPanel, '[data-signin-errors]');
      if (errors) errors.textContent = '';

      if (channel === 'email' && !isEmailValid(input.value)) {
        if (errors) errors.textContent = 'Please enter a valid email address';
        return;
      }
      if (channel === 'sms' && (input.value || '').replace(/\D/g, '').length < 7) {
        if (errors) errors.textContent = 'Please enter a valid phone number';
        return;
      }

      setLoading(true);
      setTimeout(function () {
        setLoading(false);
        goVerify();
      }, 400);
    });

    // Enter key on inputs
    qsa(sendPanel, 'input').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var btn = qs(sendPanel, '[data-send-submit]');
          if (btn && !btn.disabled) btn.click();
        }
      });
    });

    qsa(root, '[data-auth-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (timerId) clearInterval(timerId);
        show('send');
      });
    });

    var restart = qs(root, '[data-auth-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        show('send');
        setChannel('sms');
      });
    }

    var resendBtn = qs(verifyPanel, '[data-resend-btn]');
    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        expectedCode = makeCode();
        try {
          sessionStorage.setItem('florai_otp', JSON.stringify({
            channel: channel, to: contact, code: expectedCode, at: Date.now()
          }));
        } catch (e) {}
        var hint = qs(verifyPanel, '[data-otp-hint]');
        if (hint) {
          hint.innerHTML = 'Code sent. Use <strong style="color:#1f2226">' + expectedCode + '</strong> to continue.';
        }
        var realInput = qs(verifyPanel, '.otp-login-form__otp-real-input');
        if (realInput) realInput.value = '';
        var hidden = qs(verifyPanel, '[data-code-value]');
        if (hidden) hidden.value = '';
        startTimer();
      });
    }

    show('send');
    setChannel('sms');
    initIti();
    updateSubmit();
  }

  function boot() {
    document.querySelectorAll('[data-florai-signin]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
